/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, createSearchParams } from 'react-router-dom';
import {
  Box,
  Center,
  Title,
  Space,
  Group,
  Button,
  Stack,
  Image,
  ActionIcon,
  Text,
} from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconX } from '@tabler/icons';
import { useTranslation } from 'react-i18next';

import { Settings } from 'tabler-icons-react';
import { sendRequest } from '../../services/services';
import Logo from '../../image/hyperthink-logo.png';
import AppContext from '../../components/Context/index';

const Home = () => {
  const navigate = useNavigate();
  const { appState, setAppState } = useContext(AppContext);
  const siteDetails = JSON.parse(localStorage.getItem('siteDetails'));
  const { t } = useTranslation();

  const [ticketNumber, setTicketNumber] = useState('');
  const [barcodeRead, setBarcodeRead] = useState('');

  // Handle the barcode reading logic
  useEffect(() => {
    const barcode = { timing: 1000, data: '' };
    const barcodeReaded = () => {
      if (barcode.data.length > 1) {
        setBarcodeRead(barcode.data);
      } else {
        barcode.data = '';
      }
    };

    let timeout;
    const onKeyPress = (e) => {
      if (barcode.data.length === 0 || e.timeStamp - barcode.timing < 1000) {
        barcode.data += e.key;
        barcode.timing = e.timeStamp;
        clearTimeout(timeout);
        timeout = setTimeout(barcodeReaded, 500);
      } else {
        barcode.data = '';
      }
    };

    window.addEventListener('keypress', onKeyPress);

    return () => {
      window.removeEventListener('keypress', onKeyPress);
      clearTimeout(timeout);
    };
  }, []);

  // Handle ticket number extraction and validation
  useEffect(() => {
    if (!barcodeRead) return;

    const ticketValue = barcodeRead.split('/home')[1]?.slice(37);
    setTicketNumber(ticketValue);

    if (ticketNumber) {
      sendRequest(`parking/site-id-by-pass-id/${ticketNumber}`, 'get').then((data) => {
        if (data?.data?.site_id === siteDetails?.siteId) {
          sendRequest(`parking/reservations-by-pass-id/${ticketNumber}`, 'get').then((res) => {
            if (res?.code === 20) {
              navigate({
                pathname: '/addVas',
                search: createSearchParams({ passId: ticketNumber }).toString(),
              });
            } else if (res?.code === 21) {
              showNotification({
                title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
                icon: <IconX size={16} />,
              });
            }
          });
        } else {
          showNotification({
            title: <Text weight={500}>{t('enter.invalid.site.id')}</Text>,
            icon: <IconX size={16} />,
          });
        }
      });
    }
  }, [ticketNumber, barcodeRead, t, siteDetails?.siteId]);

  // Handle navigation for payment stations
  const navigateToPayment = (language) => {
    setAppState({ language });
    navigate('/payment/scan');
  };

  return (
    <Box>
      <ActionIcon variant="transparent" color="black" onClick={() => navigate('/settings')}>
        <Settings size={16} />
      </ActionIcon>

      <Center>
        <Stack>
          <Center>
            <Image src={Logo} style={{ width: '30%' }} radius="md" />
          </Center>
          <Center>
            <Stack>
              <Title style={{ color: '#F9D923' }} order={1}>
                {!!siteDetails?.siteName}{' '}
                {appState.language === 'ar' ? 'مرحبا بكم في مواقف' : 'Welcome to the'}{' '}
                {siteDetails?.siteName} Parking !!
              </Title>
            </Stack>
          </Center>
        </Stack>
      </Center>

      <Space h="xl" />

      <Center>
        <Group spacing="xl">
          <Stack>
            <Button
              shadow="md"
              p="xl"
              radius="md"
              withBorder
              onClick={() => navigateToPayment('ar')}
              sx={{
                width: '220px',
                height: '200px',
                cursor: 'pointer',
                backgroundColor: 'white',
                border: 'grey solid',
              }}
              disabled={siteDetails?.siteId === '' && siteDetails?.comPortNumber === ''}
            >
              <Center>
                <Title order={1} size="h1" sx={{ color: '#01AA84', fontSize: '60px' }} py="xl">
                  عربي
                </Title>
              </Center>
            </Button>
          </Stack>

          <Stack>
            <Button
              shadow="md"
              p="xl"
              radius="md"
              withBorder
              onClick={() => navigateToPayment('en')}
              sx={{
                width: '220px',
                height: '200px',
                cursor: 'pointer',
                backgroundColor: 'white',
                border: 'grey solid',
              }}
              disabled={siteDetails?.siteId === '' && siteDetails?.comPortNumber === ''}
            >
              <Center py="xs">
                <Title order={1} size="h1" sx={{ color: '#01AA84', fontSize: '50px' }} py="xl">
                  English
                </Title>
              </Center>
            </Button>
          </Stack>
        </Group>
      </Center>
    </Box>
  );
};

export default Home;
